import { render, staticRenderFns } from "./SubDistrict.vue?vue&type=template&id=9824e15a"
import script from "./SubDistrict.vue?vue&type=script&lang=js"
export * from "./SubDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports